
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93TA47HRMMoKdPmZ9PbofhzS3Jx2D_45ZO2zpevTpyTVt_454Meta } from "/build/pages/[...slug].vue?macro=true";
import { default as indexow9d9MEeaLo9f_45ttQ0wUj6IsAtgO_458p2pf6vL5abQBAMeta } from "/build/pages/[[lang]]/cart/index.vue?macro=true";
import { default as index_45cXKfkRNvdxnaBwfnPi_45HRnxdiqw0h4HcFk2PVMI_PIMeta } from "/build/pages/[[lang]]/login/index.vue?macro=true";
import { default as _91product_93lOYXzRk7MQ_cA3VEvjmJbdQEeYVHX2quE_45YB_459wYQzsMeta } from "/build/pages/[[lang]]/p/[product].vue?macro=true";
import { default as index3YTKj9m2vyyrX5zMMsVBtqDWMk2H8jV6wyEt4OpVvkUMeta } from "/build/pages/[[lang]]/logout/index.vue?macro=true";
import { default as indexVllTYUyoyQRCQDIKLNTxW8o_45nA3jDTyu8WnKjMzfxd8Meta } from "/build/pages/[[lang]]/search/index.vue?macro=true";
import { default as _91slug_93_45bWvv_453kbgJ8ECLx7ziez01IXm9Fx41DL5YhCE3JykIMeta } from "/build/pages/[[lang]]/stores/[slug].vue?macro=true";
import { default as indexV0SwPAGVU1_45HWLBNEKjsCYgdmzMmUIc_45VKUZtiI3leIMeta } from "/build/pages/[[lang]]/checkout/index.vue?macro=true";
import { default as index9EmhfTrTyaOynEJWBW_MhtmQGep66Gbup5Y5CasN5CwMeta } from "/build/pages/[[lang]]/register/index.vue?macro=true";
import { default as data6zIugx7c68JRF1bVizZZ3hhj8XVGgTgud1KKKkdo2Q8Meta } from "/build/pages/[[lang]]/my-account/data.vue?macro=true";
import { default as petstz8TUJA4L_45IJbjhYNEEJn1BnCx9YZHnscysvVgksAoAMeta } from "/build/pages/[[lang]]/my-account/pets.vue?macro=true";
import { default as indexGE6y39lF2Btn_ELjvyJD_HlpWIxithT5F_RAOBS7_ysMeta } from "/build/pages/[[lang]]/my-account/index.vue?macro=true";
import { default as step_45date1rTvZtpfD_utWcOg1Jh07GeEPc_wxdNQxT_hZklVfeUMeta } from "/build/pages/[[lang]]/booking/step-date.vue?macro=true";
import { default as step_45timeuNrGs2Dzh534pX_nJXBDF4FDgMz55L9aD_45YPBtPfEuMMeta } from "/build/pages/[[lang]]/booking/step-time.vue?macro=true";
import { default as payback_45authJXNB_iJpxtnshSoX_zxX1BhnQc2ihWewx1oEqH8NDhsMeta } from "/build/pages/[[lang]]/cart/payback-auth.vue?macro=true";
import { default as index4JymP9dQMxWACKjLOq3KaGUyuBvBU1e0srQ6YAX9q5YMeta } from "/build/pages/[[lang]]/storefinder/index.vue?macro=true";
import { default as step_45loginxqEKaLM7lMux7Lo1Jg49Ohe7jr_45D4EjvLpSN61xPjdMMeta } from "/build/pages/[[lang]]/booking/step-login.vue?macro=true";
import { default as step_45startXQLEt2egKNHKzdhxmXs1wwYvFVl_blG82RhlnIRAPlgMeta } from "/build/pages/[[lang]]/booking/step-start.vue?macro=true";
import { default as payback_45errorCRMbFwgvwFYMo9wuPvPz4BMBLj3vEx0WhVgkImPojXoMeta } from "/build/pages/[[lang]]/cart/payback-error.vue?macro=true";
import { default as paybackceZOUyQqjuE008NcPNzqyktVChoEI7cQD8sfgS1GseEMeta } from "/build/pages/[[lang]]/my-account/payback.vue?macro=true";
import { default as payment2mCZoGIV6x_459U5w7iK82u81KbIKKAJFVXHGRVg2SAecMeta } from "/build/pages/[[lang]]/my-account/payment.vue?macro=true";
import { default as _91_91orderId_93_93KB_C0qS_45bOzfosP6p0pnopVytbifsorgYZNaZdTa8t8Meta } from "/build/pages/[[lang]]/return/[[orderId]].vue?macro=true";
import { default as indexdtVBimfhf6RtPhSPRSHZP947OSNcBxRujdq7jcFj7vEMeta } from "/build/pages/[[lang]]/store-editor/index.vue?macro=true";
import { default as wishlist1cAu8xoRhYmcq5Kercti87kA1fcwkitoM5X0h8PVBFMMeta } from "/build/pages/[[lang]]/my-account/wishlist.vue?macro=true";
import { default as step_45summarybjBxMSB_45cQZYthQAeCprC1t1H71duXhcarxRjU5NZ8AMeta } from "/build/pages/[[lang]]/booking/step-summary.vue?macro=true";
import { default as payback_45successWf8HUxCVB01e6xy0EVXHFa_zyP7Im8Qi6AVUip2lHW8Meta } from "/build/pages/[[lang]]/cart/payback-success.vue?macro=true";
import { default as indexS5i4vWZcP9eUy6CYjtxfXLeq5Z53esHdSB839hu2wKMMeta } from "/build/pages/[[lang]]/checkout/start/index.vue?macro=true";
import { default as addressesInhkO9PGX3PiDqOnlQc9LjtbnGtD2mXDteA54UBy0y0Meta } from "/build/pages/[[lang]]/my-account/addresses.vue?macro=true";
import { default as buy_45again3q2bRo0OnA6knkTFkkTbuREzSIKDBKWmwhh2JdKf6oQMeta } from "/build/pages/[[lang]]/my-account/buy-again.vue?macro=true";
import { default as step_45name_45petVAoZYKkgWPBHcz3YYIrppSR7eJA1chx9_BeW9ZLNcgsMeta } from "/build/pages/[[lang]]/booking/step-name-pet.vue?macro=true";
import { default as step_45race_45petMlUj62OEg1CKxZohYh2XsDmGlaSf4H0pQ72QxvjefwAMeta } from "/build/pages/[[lang]]/booking/step-race-pet.vue?macro=true";
import { default as step_45registern9BVDxFDSlneibJRXAN2q07FmAbetsMuOa63r6veHA0Meta } from "/build/pages/[[lang]]/booking/step-register.vue?macro=true";
import { default as step_45size_45petaEe0aHQza4Z0Sj_JhXBI9HHdIrVGV_tATNMRi7IUm6gMeta } from "/build/pages/[[lang]]/booking/step-size-pet.vue?macro=true";
import { default as newsletter6ZpyEZoSqW8fi3IhjlkNsPseniGqDlBCQ5DidNLqLYAMeta } from "/build/pages/[[lang]]/my-account/newsletter.vue?macro=true";
import { default as step_45date_45timeWVp_45oitRW1mkM5nAsRCGvh2eICHZ0siqAWVZl5e2URUMeta } from "/build/pages/[[lang]]/booking/step-date-time.vue?macro=true";
import { default as step_45visit_45pet3G1CCU50w2BiyO4OlGcqaxYB6rxSVBHIKc51s3Bh0hIMeta } from "/build/pages/[[lang]]/booking/step-visit-pet.vue?macro=true";
import { default as indexontqbmRGDsaLjOmTjPuFlwg9N4s1XSYePTylU87nutcMeta } from "/build/pages/[[lang]]/checkout/address/index.vue?macro=true";
import { default as indexeUNFnAMFibGUvw1kwY2O_45Pk6K6iTHbo5Uv0Jy2x3KywMeta } from "/build/pages/[[lang]]/checkout/payment/index.vue?macro=true";
import { default as indexoFBrOKeu2FCdOOxOvZ8m_45VTNzEICs_DOvx3OhlaIxpsMeta } from "/build/pages/[[lang]]/checkout/summary/index.vue?macro=true";
import { default as indexawg_45mP2FFcs0ihCHFoGH_QIs7MUUPJyjEwtsXrLwWz0Meta } from "/build/pages/[[lang]]/password/request/index.vue?macro=true";
import { default as step_45gender_45petY_1b3OWno6SdDlmjtHVqgUgRVBS8h2X46CWPGVaNH8oMeta } from "/build/pages/[[lang]]/booking/step-gender-pet.vue?macro=true";
import { default as step_45matted_45petDfNkewdCHv_DHks8PksDgBVr_45dgP_45LsUDDITc7ksTC4Meta } from "/build/pages/[[lang]]/booking/step-matted-pet.vue?macro=true";
import { default as step_45select_45pet_5hYlK4HhW5PfFOPjaUC3Y6qybIMy3UmB_jA4DGeqiIMeta } from "/build/pages/[[lang]]/booking/step-select-pet.vue?macro=true";
import { default as index5w_mHVZWhl37ldQjnavXLqMVIUCEBW7xw0gvcxRWzG8Meta } from "/build/pages/[[lang]]/checkout/delivery/index.vue?macro=true";
import { default as indexHSrnceSvRNbrvYYFi41LPmu355ovbZKO9u4XnfhBEFYMeta } from "/build/pages/[[lang]]/my-account/orders/index.vue?macro=true";
import { default as indexBAWDnRBs8YBF_45_oialxrpOjQwDNEd9hSK9b1FI2WnJ0Meta } from "/build/pages/[[lang]]/store-editor/data/index.vue?macro=true";
import { default as step_45coat_45length14RdCNFaU9Mgzv6CZdURBnnc99rY6QMx5A30eLSKnZUMeta } from "/build/pages/[[lang]]/booking/step-coat-length.vue?macro=true";
import { default as indexFxPXtahWK4TgDrllZvQiVuYWnFmuNrb7rCTa82fagFAMeta } from "/build/pages/[[lang]]/my-account/friends/index.vue?macro=true";
import { default as _91id_93WJBJOVULGKV7cZilDbDaFJLLtTAMQ0iZh0Cpwxp6DcgMeta } from "/build/pages/[[lang]]/store-editor/detail/[id].vue?macro=true";
import { default as _91id_93dxKVrzEDYEGwkn4rmZ4Ms_xfYTjIFVnwyK7V6rXYj1EMeta } from "/build/pages/[[lang]]/booking/cancellation/[id].vue?macro=true";
import { default as step_45birthday_45petmHfMTW5T3CBjBJMvdJ3OzDKaqv0pC22TTGYCU1qRpMQMeta } from "/build/pages/[[lang]]/booking/step-birthday-pet.vue?macro=true";
import { default as step_45confirmationLQ87j4Ptas6rm6FonWgLQbXxNQDHEdxbP_45dX59mVvDsMeta } from "/build/pages/[[lang]]/booking/step-confirmation.vue?macro=true";
import { default as indexHUbQidtWXS7KTJ1aI5LCvxexh9lM3lXFqDmy6xt_45EL0Meta } from "/build/pages/[[lang]]/checkout/native-3ds/index.vue?macro=true";
import { default as indexmIYZJaNfG1Nny802526avyWp9VvtgOTBvb_llfhnbZUMeta } from "/build/pages/[[lang]]/my-account/deletion/index.vue?macro=true";
import { default as step_45lifephase_45petHTvJ7rzA_45dm56qBWDsuNKrbVJylES7YUFfTVqtEejCMMeta } from "/build/pages/[[lang]]/booking/step-lifephase-pet.vue?macro=true";
import { default as step_45personal_45datasdvJ6Ygb1OjTEZTtKD_rtCg16u7PnwvjMQ2v6lv119sMeta } from "/build/pages/[[lang]]/booking/step-personal-data.vue?macro=true";
import { default as recommendationsOs1k8HI0J1R_45IqXYbXZgCK_52G8_ky6gtBWlm1t6XyEMeta } from "/build/pages/[[lang]]/my-account/recommendations.vue?macro=true";
import { default as step_45castration_45petzALyU_hj9IAv_wAvoEm0RBUezqO3CbPlhQ_7cysR3UkMeta } from "/build/pages/[[lang]]/booking/step-castration-pet.vue?macro=true";
import { default as indexc3k5V3nbQTsZ_UD68gPrfC_orrEcRSKohTQbrRsoangMeta } from "/build/pages/[[lang]]/checkout/confirmation/index.vue?macro=true";
import { default as indexG5TWL97fM171qzX8t2hpFM9St1ebphlrSc5ufbtSOy0Meta } from "/build/pages/[[lang]]/checkout/payment/blik/index.vue?macro=true";
import { default as _91id_93GPiLfocK74lq3eHiX_45q49k_45HNp_sfi0Qk1VjlZWWJK4Meta } from "/build/pages/[[lang]]/my-account/orders/help/[id].vue?macro=true";
import { default as _91id_93RZzZcz2N3Cm_hQthbfJqiBysEYVdLMaEhxg_qwDvkRMMeta } from "/build/pages/[[lang]]/newsletter/unsubscribe/[id].vue?macro=true";
import { default as _91id_93ELOwthBEvYjVZgYk3kpUj9pLeakoR8c6k_45ClP4ESYmcMeta } from "/build/pages/[[lang]]/newsletter/confirmation/[id].vue?macro=true";
import { default as index_45bgoAGo9g8amdMoF2P1e708RglPAt_457IkRs2RrGsZs8Meta } from "/build/pages/[[lang]]/password/reset/expired/index.vue?macro=true";
import { default as indexqwq9Lz5Zq8RNG1uiXpJ2Uv94fp0LZr4lnBhwv6M_454Z8Meta } from "/build/pages/[[lang]]/store-editor/dashboard/index.vue?macro=true";
import { default as indexeG4PYT_45C3IlmIdZDRR_7DrBSZdjgHsT4Bx53_dIkX8cMeta } from "/build/pages/[[lang]]/my-account/friends/paws/index.vue?macro=true";
import { default as indexQGc6AtcqeBnpgA_45rs7lq2IgfV3FdL6hnMYbvyT_453mQEMeta } from "/build/pages/[[lang]]/password/reset/password/index.vue?macro=true";
import { default as step_45package_45selectionCKVVLJvoM4O0JZjuew6lls6BENIQfouxAGRCvLXTDT0Meta } from "/build/pages/[[lang]]/booking/step-package-selection.vue?macro=true";
import { default as payment_45redirect_45errorjfLfz_IA6Sr1CQBvtNRtyYrXPRfo4um6sdWTwnI_A_45AMeta } from "/build/pages/[[lang]]/checkout/payment-redirect-error.vue?macro=true";
import { default as indexl57ppLh9HZnA0PeWqQUqImEZuNiYORamAsKdV_YlqIcMeta } from "/build/pages/[[lang]]/checkout/payment/payconiq/index.vue?macro=true";
import { default as rewardsjFQjOLWVGoNqcQyGajAD6lRRAsHfVcbpz6DiKc0Z7jIMeta } from "/build/pages/[[lang]]/my-account/friends/paws/rewards.vue?macro=true";
import { default as confirmationg0BuGrgpjs2ZeUeyT53Ri4uIzLgHU2LS3vyeD0UETWQMeta } from "/build/pages/[[lang]]/my-account/deletion/confirmation.vue?macro=true";
import { default as _91order_93tVFO42wU1ml7IrxmQry4tuw6LmLKhkidpHANxHx5XjYMeta } from "/build/pages/[[lang]]/my-account/orders/detail/[order].vue?macro=true";
import { default as _91action_93v4ofFQ2GHDh5B2fgC7U6eTABNipJCpmtFjCWqxEzb_458Meta } from "/build/pages/[[lang]]/newsletter/subscription/[action].vue?macro=true";
import { default as indexJ7iBUqeMo2VHQGbnP_SnXLWYJ_452NNPHiZ7gWxzwuHUsMeta } from "/build/pages/[[lang]]/password/request/thank-you/index.vue?macro=true";
import { default as payment_45redirect_45successkSW8LjUxLHQh_9a_7QF6XqWYCfH61VCFmNZNoEpEBLEMeta } from "/build/pages/[[lang]]/checkout/payment-redirect-success.vue?macro=true";
import { default as _91_91id_93_93VjOWc4Uc0FWs8twipBhVGSwsuo_DBMN6JMnFezLgGNoMeta } from "/build/pages/[[lang]]/newsletter/edit-preferences/[[id]].vue?macro=true";
import { default as step_45additional_45information_459Yx9PoXFqcE7AE0csigmLaGVOgXiY94Dp5ZuofRUp8Meta } from "/build/pages/[[lang]]/booking/step-additional-information.vue?macro=true";
import { default as confirmationy4LRN9Ll203mWNgEcV81rbMOLgzO4VUbAF_45h7R4NF2EMeta } from "/build/pages/[[lang]]/my-account/orders/help/confirmation.vue?macro=true";
import { default as indexRzlDggS1ViOqGcAbtACzjWJcJZYS4zJE_t11b_DYgscMeta } from "/build/pages/[[lang]]/my-account/friends/unsubscribe/index.vue?macro=true";
import { default as _91id_93TliRTRbIRrFDM2OHAqpEcXSx2jxca5DLrVNx3Dk_qJsMeta } from "/build/pages/[[lang]]/newsletter/campaign/unsubscribe/[id].vue?macro=true";
import { default as indexRnq_XIo_451h_0YEvXKDz9MdbX_7yEx0pYvO3dqwPjSCAMeta } from "/build/pages/[[lang]]/subscription/newsletter/preferences/index.vue?macro=true";
import { default as indexQ2EOuQQi9UqqUZRVu5uv_45oeyhQvCx3SScJKPgNxFMwgMeta } from "/build/pages/[[lang]]/subscription/newsletter/unsubscribe/index.vue?macro=true";
export default [
  {
    name: "catchall",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93TA47HRMMoKdPmZ9PbofhzS3Jx2D_45ZO2zpevTpyTVt_454Meta || {},
    component: () => import("/build/pages/[...slug].vue")
  },
  {
    name: "cart",
    path: "/:lang?/cart",
    meta: indexow9d9MEeaLo9f_45ttQ0wUj6IsAtgO_458p2pf6vL5abQBAMeta || {},
    component: () => import("/build/pages/[[lang]]/cart/index.vue")
  },
  {
    name: "login",
    path: "/:lang?/login",
    meta: { ...(index_45cXKfkRNvdxnaBwfnPi_45HRnxdiqw0h4HcFk2PVMI_PIMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/build/pages/[[lang]]/login/index.vue")
  },
  {
    name: "product-detail",
    path: "/:lang?/p/:product()",
    meta: _91product_93lOYXzRk7MQ_cA3VEvjmJbdQEeYVHX2quE_45YB_459wYQzsMeta || {},
    component: () => import("/build/pages/[[lang]]/p/[product].vue")
  },
  {
    name: "logout",
    path: "/:lang?/logout",
    meta: index3YTKj9m2vyyrX5zMMsVBtqDWMk2H8jV6wyEt4OpVvkUMeta || {},
    component: () => import("/build/pages/[[lang]]/logout/index.vue")
  },
  {
    name: "search",
    path: "/:lang?/search",
    meta: indexVllTYUyoyQRCQDIKLNTxW8o_45nA3jDTyu8WnKjMzfxd8Meta || {},
    component: () => import("/build/pages/[[lang]]/search/index.vue")
  },
  {
    name: "stores",
    path: "/:lang?/stores/:slug()",
    meta: _91slug_93_45bWvv_453kbgJ8ECLx7ziez01IXm9Fx41DL5YhCE3JykIMeta || {},
    component: () => import("/build/pages/[[lang]]/stores/[slug].vue")
  },
  {
    name: "checkout",
    path: "/:lang?/checkout",
    meta: { ...(indexV0SwPAGVU1_45HWLBNEKjsCYgdmzMmUIc_45VKUZtiI3leIMeta || {}), ...{"middleware":["requires-hard-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/index.vue")
  },
  {
    name: "register",
    path: "/:lang?/register",
    meta: { ...(index9EmhfTrTyaOynEJWBW_MhtmQGep66Gbup5Y5CasN5CwMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/build/pages/[[lang]]/register/index.vue")
  },
  {
    name: "account-data",
    path: "/:lang?/my-account/data",
    meta: { ...(data6zIugx7c68JRF1bVizZZ3hhj8XVGgTgud1KKKkdo2Q8Meta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/data.vue")
  },
  {
    name: "account-pets",
    path: "/:lang?/my-account/pets",
    meta: { ...(petstz8TUJA4L_45IJbjhYNEEJn1BnCx9YZHnscysvVgksAoAMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/pets.vue")
  },
  {
    name: "account",
    path: "/:lang?/my-account",
    meta: { ...(indexGE6y39lF2Btn_ELjvyJD_HlpWIxithT5F_RAOBS7_ysMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/index.vue")
  },
  {
    name: "salon-booking-step-date",
    path: "/:lang?/booking/step-date",
    meta: step_45date1rTvZtpfD_utWcOg1Jh07GeEPc_wxdNQxT_hZklVfeUMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-date.vue")
  },
  {
    name: "salon-booking-step-time",
    path: "/:lang?/booking/step-time",
    meta: step_45timeuNrGs2Dzh534pX_nJXBDF4FDgMz55L9aD_45YPBtPfEuMMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-time.vue")
  },
  {
    name: "lang-cart-payback-auth",
    path: "/:lang?/cart/payback-auth",
    meta: {"middleware":"cart-payback-auth"},
    component: () => import("/build/pages/[[lang]]/cart/payback-auth.vue")
  },
  {
    name: "store-listing",
    path: "/:lang?/storefinder",
    meta: index4JymP9dQMxWACKjLOq3KaGUyuBvBU1e0srQ6YAX9q5YMeta || {},
    component: () => import("/build/pages/[[lang]]/storefinder/index.vue")
  },
  {
    name: "step-login",
    path: "/:lang?/booking/step-login",
    meta: step_45loginxqEKaLM7lMux7Lo1Jg49Ohe7jr_45D4EjvLpSN61xPjdMMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-login.vue")
  },
  {
    name: "salon-booking-step-start",
    path: "/:lang?/booking/step-start",
    meta: step_45startXQLEt2egKNHKzdhxmXs1wwYvFVl_blG82RhlnIRAPlgMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-start.vue")
  },
  {
    name: "cart-payback-error",
    path: "/:lang?/cart/payback-error",
    meta: payback_45errorCRMbFwgvwFYMo9wuPvPz4BMBLj3vEx0WhVgkImPojXoMeta || {},
    component: () => import("/build/pages/[[lang]]/cart/payback-error.vue")
  },
  {
    name: "account-payback",
    path: "/:lang?/my-account/payback",
    meta: { ...(paybackceZOUyQqjuE008NcPNzqyktVChoEI7cQD8sfgS1GseEMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/payback.vue")
  },
  {
    name: "account-payment",
    path: "/:lang?/my-account/payment",
    meta: { ...(payment2mCZoGIV6x_459U5w7iK82u81KbIKKAJFVXHGRVg2SAecMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/payment.vue")
  },
  {
    name: "orderReturn",
    path: "/:lang?/return/:orderId?",
    meta: _91_91orderId_93_93KB_C0qS_45bOzfosP6p0pnopVytbifsorgYZNaZdTa8t8Meta || {},
    component: () => import("/build/pages/[[lang]]/return/[[orderId]].vue")
  },
  {
    name: "store-editor-login",
    path: "/:lang?/store-editor",
    meta: { ...(indexdtVBimfhf6RtPhSPRSHZP947OSNcBxRujdq7jcFj7vEMeta || {}), ...{"middleware":["anonymous-editor"]} },
    component: () => import("/build/pages/[[lang]]/store-editor/index.vue")
  },
  {
    name: "account-wishlist",
    path: "/:lang?/my-account/wishlist",
    meta: { ...(wishlist1cAu8xoRhYmcq5Kercti87kA1fcwkitoM5X0h8PVBFMMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/wishlist.vue")
  },
  {
    name: "salon-booking-step-summary",
    path: "/:lang?/booking/step-summary",
    meta: step_45summarybjBxMSB_45cQZYthQAeCprC1t1H71duXhcarxRjU5NZ8AMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-summary.vue")
  },
  {
    name: "cart-payback-success",
    path: "/:lang?/cart/payback-success",
    meta: payback_45successWf8HUxCVB01e6xy0EVXHFa_zyP7Im8Qi6AVUip2lHW8Meta || {},
    component: () => import("/build/pages/[[lang]]/cart/payback-success.vue")
  },
  {
    name: "checkout-start",
    path: "/:lang?/checkout/start",
    meta: { ...(indexS5i4vWZcP9eUy6CYjtxfXLeq5Z53esHdSB839hu2wKMMeta || {}), ...{"middleware":["requires-hard-login","checkout-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/start/index.vue")
  },
  {
    name: "account-addresses",
    path: "/:lang?/my-account/addresses",
    meta: { ...(addressesInhkO9PGX3PiDqOnlQc9LjtbnGtD2mXDteA54UBy0y0Meta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/addresses.vue")
  },
  {
    name: "account-buy-again",
    path: "/:lang?/my-account/buy-again",
    meta: { ...(buy_45again3q2bRo0OnA6knkTFkkTbuREzSIKDBKWmwhh2JdKf6oQMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/buy-again.vue")
  },
  {
    name: "step-name-pet",
    path: "/:lang?/booking/step-name-pet",
    meta: step_45name_45petVAoZYKkgWPBHcz3YYIrppSR7eJA1chx9_BeW9ZLNcgsMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-name-pet.vue")
  },
  {
    name: "step-race-pet",
    path: "/:lang?/booking/step-race-pet",
    meta: step_45race_45petMlUj62OEg1CKxZohYh2XsDmGlaSf4H0pQ72QxvjefwAMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-race-pet.vue")
  },
  {
    name: "salon-booking-step-register",
    path: "/:lang?/booking/step-register",
    meta: step_45registern9BVDxFDSlneibJRXAN2q07FmAbetsMuOa63r6veHA0Meta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-register.vue")
  },
  {
    name: "step-size-pet",
    path: "/:lang?/booking/step-size-pet",
    meta: step_45size_45petaEe0aHQza4Z0Sj_JhXBI9HHdIrVGV_tATNMRi7IUm6gMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-size-pet.vue")
  },
  {
    name: "account-newsletter",
    path: "/:lang?/my-account/newsletter",
    meta: { ...(newsletter6ZpyEZoSqW8fi3IhjlkNsPseniGqDlBCQ5DidNLqLYAMeta || {}), ...{"middleware":["requires-hard-login","authenticated","newsletter"]} },
    component: () => import("/build/pages/[[lang]]/my-account/newsletter.vue")
  },
  {
    name: "salon-booking-step-date-time",
    path: "/:lang?/booking/step-date-time",
    meta: step_45date_45timeWVp_45oitRW1mkM5nAsRCGvh2eICHZ0siqAWVZl5e2URUMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-date-time.vue")
  },
  {
    name: "step-visit-pet",
    path: "/:lang?/booking/step-visit-pet",
    meta: step_45visit_45pet3G1CCU50w2BiyO4OlGcqaxYB6rxSVBHIKc51s3Bh0hIMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-visit-pet.vue")
  },
  {
    name: "checkout-address",
    path: "/:lang?/checkout/address",
    meta: { ...(indexontqbmRGDsaLjOmTjPuFlwg9N4s1XSYePTylU87nutcMeta || {}), ...{"middleware":["requires-hard-login","checkout-address"]} },
    component: () => import("/build/pages/[[lang]]/checkout/address/index.vue")
  },
  {
    name: "checkout-payment",
    path: "/:lang?/checkout/payment",
    meta: { ...(indexeUNFnAMFibGUvw1kwY2O_45Pk6K6iTHbo5Uv0Jy2x3KywMeta || {}), ...{"middleware":["requires-hard-login","checkout-payment"]} },
    component: () => import("/build/pages/[[lang]]/checkout/payment/index.vue")
  },
  {
    name: "checkout-summary",
    path: "/:lang?/checkout/summary",
    meta: { ...(indexoFBrOKeu2FCdOOxOvZ8m_45VTNzEICs_DOvx3OhlaIxpsMeta || {}), ...{"middleware":["requires-hard-login","checkout-summary"]} },
    component: () => import("/build/pages/[[lang]]/checkout/summary/index.vue")
  },
  {
    name: "password-request",
    path: "/:lang?/password/request",
    meta: indexawg_45mP2FFcs0ihCHFoGH_QIs7MUUPJyjEwtsXrLwWz0Meta || {},
    component: () => import("/build/pages/[[lang]]/password/request/index.vue")
  },
  {
    name: "step-gender-pet",
    path: "/:lang?/booking/step-gender-pet",
    meta: step_45gender_45petY_1b3OWno6SdDlmjtHVqgUgRVBS8h2X46CWPGVaNH8oMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-gender-pet.vue")
  },
  {
    name: "step-matted-pet",
    path: "/:lang?/booking/step-matted-pet",
    meta: step_45matted_45petDfNkewdCHv_DHks8PksDgBVr_45dgP_45LsUDDITc7ksTC4Meta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-matted-pet.vue")
  },
  {
    name: "step-select-pet",
    path: "/:lang?/booking/step-select-pet",
    meta: step_45select_45pet_5hYlK4HhW5PfFOPjaUC3Y6qybIMy3UmB_jA4DGeqiIMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-select-pet.vue")
  },
  {
    name: "checkout-delivery",
    path: "/:lang?/checkout/delivery",
    meta: { ...(index5w_mHVZWhl37ldQjnavXLqMVIUCEBW7xw0gvcxRWzG8Meta || {}), ...{"middleware":["requires-hard-login","checkout-delivery"]} },
    component: () => import("/build/pages/[[lang]]/checkout/delivery/index.vue")
  },
  {
    name: "lang-my-account-orders",
    path: "/:lang?/my-account/orders",
    meta: {"middleware":["requires-hard-login","authenticated"]},
    component: () => import("/build/pages/[[lang]]/my-account/orders/index.vue")
  },
  {
    name: "store-editor-data",
    path: "/:lang?/store-editor/data",
    meta: { ...(indexBAWDnRBs8YBF_45_oialxrpOjQwDNEd9hSK9b1FI2WnJ0Meta || {}), ...{"middleware":["requires-hard-login","authenticated","store-editor"]} },
    component: () => import("/build/pages/[[lang]]/store-editor/data/index.vue")
  },
  {
    name: "step-coat-length",
    path: "/:lang?/booking/step-coat-length",
    meta: step_45coat_45length14RdCNFaU9Mgzv6CZdURBnnc99rY6QMx5A30eLSKnZUMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-coat-length.vue")
  },
  {
    name: "account-friends",
    path: "/:lang?/my-account/friends",
    meta: indexFxPXtahWK4TgDrllZvQiVuYWnFmuNrb7rCTa82fagFAMeta || {},
    component: () => import("/build/pages/[[lang]]/my-account/friends/index.vue")
  },
  {
    name: "store-editor-detail",
    path: "/:lang?/store-editor/detail/:id()",
    meta: { ...(_91id_93WJBJOVULGKV7cZilDbDaFJLLtTAMQ0iZh0Cpwxp6DcgMeta || {}), ...{"middleware":["requires-hard-login","authenticated","store-editor"]} },
    component: () => import("/build/pages/[[lang]]/store-editor/detail/[id].vue")
  },
  {
    name: "salon-booking-step-cancel",
    path: "/:lang?/booking/cancellation/:id()",
    meta: _91id_93dxKVrzEDYEGwkn4rmZ4Ms_xfYTjIFVnwyK7V6rXYj1EMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/cancellation/[id].vue")
  },
  {
    name: "step-birthday-pet",
    path: "/:lang?/booking/step-birthday-pet",
    meta: step_45birthday_45petmHfMTW5T3CBjBJMvdJ3OzDKaqv0pC22TTGYCU1qRpMQMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-birthday-pet.vue")
  },
  {
    name: "salon-booking-step-confirmation",
    path: "/:lang?/booking/step-confirmation",
    meta: step_45confirmationLQ87j4Ptas6rm6FonWgLQbXxNQDHEdxbP_45dX59mVvDsMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-confirmation.vue")
  },
  {
    name: "checkout-adyen-3ds-challenge",
    path: "/:lang?/checkout/native-3ds",
    meta: { ...(indexHUbQidtWXS7KTJ1aI5LCvxexh9lM3lXFqDmy6xt_45EL0Meta || {}), ...{"middleware":["requires-hard-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/native-3ds/index.vue")
  },
  {
    name: "account-deletion",
    path: "/:lang?/my-account/deletion",
    meta: { ...(indexmIYZJaNfG1Nny802526avyWp9VvtgOTBvb_llfhnbZUMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/deletion/index.vue")
  },
  {
    name: "step-lifephase-pet",
    path: "/:lang?/booking/step-lifephase-pet",
    meta: step_45lifephase_45petHTvJ7rzA_45dm56qBWDsuNKrbVJylES7YUFfTVqtEejCMMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-lifephase-pet.vue")
  },
  {
    name: "salon-booking-step-personal-data",
    path: "/:lang?/booking/step-personal-data",
    meta: step_45personal_45datasdvJ6Ygb1OjTEZTtKD_rtCg16u7PnwvjMQ2v6lv119sMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-personal-data.vue")
  },
  {
    name: "account-recommendations",
    path: "/:lang?/my-account/recommendations",
    meta: { ...(recommendationsOs1k8HI0J1R_45IqXYbXZgCK_52G8_ky6gtBWlm1t6XyEMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/recommendations.vue")
  },
  {
    name: "step-castration-pet",
    path: "/:lang?/booking/step-castration-pet",
    meta: step_45castration_45petzALyU_hj9IAv_wAvoEm0RBUezqO3CbPlhQ_7cysR3UkMeta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-castration-pet.vue")
  },
  {
    name: "checkout-confirmation",
    path: "/:lang?/checkout/confirmation",
    meta: { ...(indexc3k5V3nbQTsZ_UD68gPrfC_orrEcRSKohTQbrRsoangMeta || {}), ...{"middleware":["requires-hard-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/confirmation/index.vue")
  },
  {
    name: "checkout-payment-blik",
    path: "/:lang?/checkout/payment/blik",
    meta: { ...(indexG5TWL97fM171qzX8t2hpFM9St1ebphlrSc5ufbtSOy0Meta || {}), ...{"middleware":["requires-hard-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/payment/blik/index.vue")
  },
  {
    name: "orders-contact",
    path: "/:lang?/my-account/orders/help/:id()",
    meta: { ...(_91id_93GPiLfocK74lq3eHiX_45q49k_45HNp_sfi0Qk1VjlZWWJK4Meta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/orders/help/[id].vue")
  },
  {
    name: "newsletter-unsubscribe",
    path: "/:lang?/newsletter/unsubscribe/:id()",
    meta: _91id_93RZzZcz2N3Cm_hQthbfJqiBysEYVdLMaEhxg_qwDvkRMMeta || {},
    component: () => import("/build/pages/[[lang]]/newsletter/unsubscribe/[id].vue")
  },
  {
    name: "newsletter-confirmation",
    path: "/:lang?/newsletter/confirmation/:id()",
    meta: _91id_93ELOwthBEvYjVZgYk3kpUj9pLeakoR8c6k_45ClP4ESYmcMeta || {},
    component: () => import("/build/pages/[[lang]]/newsletter/confirmation/[id].vue")
  },
  {
    name: "password-reset-expired",
    path: "/:lang?/password/reset/expired",
    meta: index_45bgoAGo9g8amdMoF2P1e708RglPAt_457IkRs2RrGsZs8Meta || {},
    component: () => import("/build/pages/[[lang]]/password/reset/expired/index.vue")
  },
  {
    name: "dashboard",
    path: "/:lang?/store-editor/dashboard",
    meta: { ...(indexqwq9Lz5Zq8RNG1uiXpJ2Uv94fp0LZr4lnBhwv6M_454Z8Meta || {}), ...{"middleware":["requires-hard-login","authenticated","store-editor"]} },
    component: () => import("/build/pages/[[lang]]/store-editor/dashboard/index.vue")
  },
  {
    name: "account-friends-paws",
    path: "/:lang?/my-account/friends/paws",
    meta: { ...(indexeG4PYT_45C3IlmIdZDRR_7DrBSZdjgHsT4Bx53_dIkX8cMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/friends/paws/index.vue")
  },
  {
    name: "password-reset-password",
    path: "/:lang?/password/reset/password",
    meta: indexQGc6AtcqeBnpgA_45rs7lq2IgfV3FdL6hnMYbvyT_453mQEMeta || {},
    component: () => import("/build/pages/[[lang]]/password/reset/password/index.vue")
  },
  {
    name: "salon-booking-step-package-selection",
    path: "/:lang?/booking/step-package-selection",
    meta: step_45package_45selectionCKVVLJvoM4O0JZjuew6lls6BENIQfouxAGRCvLXTDT0Meta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-package-selection.vue")
  },
  {
    name: "checkout-payment-redirect-error",
    path: "/:lang?/checkout/payment-redirect-error",
    meta: { ...(payment_45redirect_45errorjfLfz_IA6Sr1CQBvtNRtyYrXPRfo4um6sdWTwnI_A_45AMeta || {}), ...{"middleware":["checkout-payment-redirect-error"]} },
    component: () => import("/build/pages/[[lang]]/checkout/payment-redirect-error.vue")
  },
  {
    name: "checkout-payment-payconiq",
    path: "/:lang?/checkout/payment/payconiq",
    meta: { ...(indexl57ppLh9HZnA0PeWqQUqImEZuNiYORamAsKdV_YlqIcMeta || {}), ...{"middleware":["requires-hard-login"]} },
    component: () => import("/build/pages/[[lang]]/checkout/payment/payconiq/index.vue")
  },
  {
    name: "account-friends-paws-rewards",
    path: "/:lang?/my-account/friends/paws/rewards",
    meta: { ...(rewardsjFQjOLWVGoNqcQyGajAD6lRRAsHfVcbpz6DiKc0Z7jIMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/friends/paws/rewards.vue")
  },
  {
    name: "account-deletion-confirmation",
    path: "/:lang?/my-account/deletion/confirmation",
    meta: confirmationg0BuGrgpjs2ZeUeyT53Ri4uIzLgHU2LS3vyeD0UETWQMeta || {},
    component: () => import("/build/pages/[[lang]]/my-account/deletion/confirmation.vue")
  },
  {
    name: "lang-my-account-orders-detail-order",
    path: "/:lang?/my-account/orders/detail/:order()",
    meta: {"middleware":["requires-hard-login","authenticated"]},
    component: () => import("/build/pages/[[lang]]/my-account/orders/detail/[order].vue")
  },
  {
    name: "newsletter-action-redirect",
    path: "/:lang?/newsletter/subscription/:action()",
    meta: _91action_93v4ofFQ2GHDh5B2fgC7U6eTABNipJCpmtFjCWqxEzb_458Meta || {},
    component: () => import("/build/pages/[[lang]]/newsletter/subscription/[action].vue")
  },
  {
    name: "password-request-thank-you",
    path: "/:lang?/password/request/thank-you",
    meta: indexJ7iBUqeMo2VHQGbnP_SnXLWYJ_452NNPHiZ7gWxzwuHUsMeta || {},
    component: () => import("/build/pages/[[lang]]/password/request/thank-you/index.vue")
  },
  {
    name: "lang-checkout-payment-redirect-success",
    path: "/:lang?/checkout/payment-redirect-success",
    component: () => import("/build/pages/[[lang]]/checkout/payment-redirect-success.vue")
  },
  {
    name: "newsletter-preferences",
    path: "/:lang?/newsletter/edit-preferences/:id?",
    meta: { ...(_91_91id_93_93VjOWc4Uc0FWs8twipBhVGSwsuo_DBMN6JMnFezLgGNoMeta || {}), ...{"middleware":["newsletter"]} },
    component: () => import("/build/pages/[[lang]]/newsletter/edit-preferences/[[id]].vue")
  },
  {
    name: "step-additional-information",
    path: "/:lang?/booking/step-additional-information",
    meta: step_45additional_45information_459Yx9PoXFqcE7AE0csigmLaGVOgXiY94Dp5ZuofRUp8Meta || {},
    component: () => import("/build/pages/[[lang]]/booking/step-additional-information.vue")
  },
  {
    name: "orders-help-confirmation",
    path: "/:lang?/my-account/orders/help/confirmation",
    meta: { ...(confirmationy4LRN9Ll203mWNgEcV81rbMOLgzO4VUbAF_45h7R4NF2EMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/orders/help/confirmation.vue")
  },
  {
    name: "account-friends-unsubscribe",
    path: "/:lang?/my-account/friends/unsubscribe",
    meta: { ...(indexRzlDggS1ViOqGcAbtACzjWJcJZYS4zJE_t11b_DYgscMeta || {}), ...{"middleware":["requires-hard-login","authenticated"]} },
    component: () => import("/build/pages/[[lang]]/my-account/friends/unsubscribe/index.vue")
  },
  {
    name: "campaign-unsubscribe",
    path: "/:lang?/newsletter/campaign/unsubscribe/:id()",
    meta: { ...(_91id_93TliRTRbIRrFDM2OHAqpEcXSx2jxca5DLrVNx3Dk_qJsMeta || {}), ...{"middleware":["campaign-unsubscribe"]} },
    component: () => import("/build/pages/[[lang]]/newsletter/campaign/unsubscribe/[id].vue")
  },
  {
    name: "subscription-preferences",
    path: "/:lang?/subscription/newsletter/preferences",
    meta: indexRnq_XIo_451h_0YEvXKDz9MdbX_7yEx0pYvO3dqwPjSCAMeta || {},
    component: () => import("/build/pages/[[lang]]/subscription/newsletter/preferences/index.vue")
  },
  {
    name: "subscription-unsubscribe",
    path: "/:lang?/subscription/newsletter/unsubscribe",
    meta: indexQ2EOuQQi9UqqUZRVu5uv_45oeyhQvCx3SScJKPgNxFMwgMeta || {},
    component: () => import("/build/pages/[[lang]]/subscription/newsletter/unsubscribe/index.vue")
  }
]